import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'

interface IProps {
    open: boolean
    keyId: string
    onConfirm: () => void
    onCancel: () => void
}

// orders phase는 19개 거래소 중 16개에서 가져온 주문을 실제로 저장한다. 되돌릴 수 없으니 한 번 묻는다.
const ConfirmOrdersModal: React.FC<IProps> = ({open, keyId, onConfirm, onCancel}) => {
    if (!open) return null

    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onCancel} />
            <div className={'relative z-10 w-[90%] max-w-[480px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>주문까지 조회하시겠습니까?</Text>
                <Text className={'text-ti3 text-font03 mt-[6px] break-all'}>{keyId}</Text>

                <div className={'mt-[16px] rounded-[8px] border border-font_red bg-bg_red px-[16px] py-[12px]'}>
                    <Text className={'text-body2 text-font01'}>
                        orders phase는 읽기 전용이 아닙니다. blofin을 뺀 나머지 거래소에서는 가져온 주문이 그대로
                        저장되며, 프로덕션 sync 경로와 동일하게 동작합니다.
                    </Text>
                </div>
                <Text className={'text-body3 text-font02 mt-[10px]'}>
                    권한/자격증명 문제만 보려는 거라면 account·balance phase(읽기 전용)만으로 충분합니다.
                </Text>

                <div className={'mt-[24px] flex items-center justify-end gap-x-[10px]'}>
                    <WizButton text={'취소'} type={'cancel'} onClick={onCancel} />
                    <WizButton text={'주문 포함 실행'} type={'red'} onClick={onConfirm} />
                </div>
            </div>
        </div>
    )
}

export default ConfirmOrdersModal
